import { ApexOptions } from 'apexcharts';

// --- Base config LineChart ---
export const configLineChart = (): ApexOptions => {
  const config: ApexOptions = {
    chart: {
      toolbar: { show: false },
      zoom: { enabled: false },
      fontFamily: 'Inter',
    },
    grid: { show: false },
    stroke: { curve: 'smooth' },
    yaxis: {
      axisBorder: { show: true },
    },
    tooltip: { enabled: true },
    legend: { show: true, showForSingleSeries: true },
  };

  return config;
};

// --- Base config ColumnChart ---
export const configColumnChart = (): ApexOptions => {
  const config: ApexOptions = {
    chart: {
      toolbar: { show: false },
      zoom: { enabled: false },
      fontFamily: 'Inter',
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 6,
        borderRadiusApplication: 'end',
      },
    },
    dataLabels: { enabled: false },
    grid: { show: false },
    yaxis: {
      axisBorder: { show: true },
    },
    tooltip: { enabled: true },
    legend: { show: true, showForSingleSeries: true },
  };

  return config;
};
